import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white customer-satisfaction-box" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-sm-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { id: "wrapper" }
const _hoisted_4 = {
  key: 0,
  id: "chart"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "mb-15 mb-md-25 d-flex align-items-center justify-content-between" }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.preparedData.series != undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_apexchart, {
                type: "bar",
                height: "350",
                options: _ctx.preparedData.chartOptions,
                series: _ctx.preparedData.series
              }, null, 8, ["options", "series"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("span", null, [
      _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Ignorovat záznamy s hodnotou a menší:", -1)),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ignoreLowerThan) = $event)),
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.refreshdata())),
        class: "form-select shadow-none fw-semibold rounded-0"
      }, [...(_cache[3] || (_cache[3] = [
        _createStaticVNode("<option value=\"0\">Bez omezení</option><option value=\"1%\">1% Nejmenších</option><option value=\"5%\">5% Nejmenších</option><option value=\"1\">1</option><option value=\"5\">5</option><option value=\"10\">10</option>", 6)
      ]))], 544), [
        [_vModelSelect, _ctx.ignoreLowerThan]
      ])
    ])
  ]))
}